import api from '../api';

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
}

function preferredMethod(value) {
    if (value === 'authenticator' || value === 'email') return value;
    return '';
}

export function normalizeStudentTwoFactor(raw) {
    const source = raw && typeof raw === 'object' ? raw : {};
    const companyRequired = source.companyRequired === true;
    return {
        enabled: source.enabled === true,
        companyRequired,
        canChooseMethod: source.canChooseMethod === true,
        preferredMethod: preferredMethod(source.preferredMethod),
    };
}

export function normalizeAuthenticatorStatus(raw) {
    const source = raw && typeof raw === 'object' ? raw : {};
    return {
        required: source.required === true,
        configured: source.configured === true,
        otpauthUri: typeof source.otpauthUri === 'string' ? source.otpauthUri : '',
    };
}

export default {
    async getTwoFactor(accessToken) {
        const response = await api.get('/portal/security/two-factor', {
            headers: authHeaders(accessToken),
        });
        return normalizeStudentTwoFactor(response.data);
    },
    async updateTwoFactor(accessToken, enabled) {
        await api.put('/portal/security/two-factor', {
            enabled: enabled === true,
        }, {
            headers: authHeaders(accessToken),
        });
        return this.getTwoFactor(accessToken);
    },
    async updateTwoFactorMethod(accessToken, method) {
        await api.put('/portal/security/two-factor-method', {
            method,
        }, {
            headers: authHeaders(accessToken),
        });
        return this.getTwoFactor(accessToken);
    },
    async authenticatorStatus(accessToken) {
        const response = await api.get('/portal/authenticator/status', {
            headers: authHeaders(accessToken),
        });
        return normalizeAuthenticatorStatus(response.data);
    },
    async confirmAuthenticator(accessToken, code) {
        const response = await api.post('/portal/authenticator/confirm', {
            code,
        }, {
            headers: authHeaders(accessToken),
        });
        return normalizeAuthenticatorStatus(response.data);
    },
};
